export const LOADER_PANEL_WIDTH = 416
export const LOADER_PANEL_HEIGHT = 704
export const LOADER_PHONE_WIDTH = 480
